import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AiAskRequest, AiAskResponse } from './ai-api.models';
import { environment } from  '../../../../src/environments/environment';

/**
 * Thin client for the JMotto10 AI endpoints.
 */
@Injectable({ providedIn: 'root' })
export class AiApiService {
  private readonly baseUrl = (environment as any).apiUrl;

  constructor(private http: HttpClient) {}

  ask(request: AiAskRequest, bearerToken?: string): Observable<AiAskResponse> {
    const url = this.joinUrl(this.baseUrl, 'ai/ask');
    const headers = this.buildAuthHeaders(bearerToken);
    return this.http.post<AiAskResponse>(url, request, { headers });
  }

  askExport(request: AiAskRequest, bearerToken?: string, format: string = 'excel'): Observable<Blob> {
    const url = this.joinUrl(this.baseUrl, `ai/ask/export?format=${format}`);
    const headers = this.buildAuthHeaders(bearerToken);
    return this.http.post(url, request, { headers, responseType: 'blob' });
  }

  private buildAuthHeaders(bearerToken?: string): HttpHeaders {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (bearerToken && bearerToken.trim().length > 0) {
      headers = headers.set('Authorization', bearerToken.startsWith('Bearer ') ? bearerToken : `Bearer ${bearerToken}`);
    }
    return headers;
  }

  private joinUrl(base: string, path: string): string {
    const b = (base || '').replace(/\/+$/, '');
    const p = (path || '').replace(/^\/+/, '');
    return `${b}/${p}`;
  }
}
